import { gql } from "@apollo/client";

const GET_LEVEL_RECOMMENDATION = gql`
  query LevelRecommendation($languageId: ID!) {
    levelRecommendation(languageId: $languageId) {
      language {
        id
        englishName
      }
      currentLevel {
        id
        title
      }
      curriculumLevel {
        id
        title
      }
      status
      studiedTopics
      totalTopics
      evaluationCount
    }
  }
`;

export default GET_LEVEL_RECOMMENDATION;
